import { mapGetters } from 'vuex';
import { trackSecondaryEvent } from '@/lib/rudderstack-helper';

export default {
  watch: {
    'app.design': {
      handler() {
        // This ensures the style sheet generated by the Style Engine reflects these changes for any previews
        this.app.buildDesignStyleSheet();
      },
      deep: true,
    },
  },
  data() {
    return {
      colorHasChanged: false,
    };
  },
  computed: {
    ...mapGetters([
      'app',
      'applicationHasPendingDesignChanges',
    ]),
  },
  created() {
    // Check if this is the first change
    if (!this.applicationHasPendingDesignChanges) {
      // Create our backup so we can restore with any cancels
      this.$store.dispatch('createAppDesignSettingsBackup');
    }
  },
  methods: {
    ...mapGetters([
      'updateApplication',
    ]),
    onSaveAppDesignSettings() {
      const update = {
        design: this.$store.state.app.design,
      };

      this.commitRequest({
        request: () => this.app.update(update),
        onSuccess: (response) => {
          trackSecondaryEvent('saved_design_settings', {}, 10); // 10 seconds throttle for design settings

          if (this.colorHasChanged) {
            trackSecondaryEvent('colors_changed', {}, 10); // 10 seconds throttle for color changes

            this.colorHasChanged = false;
          }

          this.$store.commit('setApplicationHasPendingDesignChanges', false);

          // Create our backup so we can restore with any cancels
          this.$store.dispatch('createAppDesignSettingsBackup');

          // Confirmed save from navigation guard, so continue to that path
          if (this.navigationGuard.showConfirm) {
            this.navigationGuard.showConfirm = false;

            return this.$router.push(this.navigationGuard.path);
          }
        },
      });
    },
    onCancelAppDesignSettings() {
      this.$store.dispatch('restoreAppDesignSettingsBackup');

      if (this.navigationGuard.showConfirm) {
        this.navigationGuard.showConfirm = false;
      }
    },
    onColorHasChanged() {
      this.colorHasChanged = true;
    },
  },
};
